import { useState } from "react";
import useProject from "../../../../../hooks/UseProject";
import { Building, MapType, Resource, Unit } from "../../../../types/project";
import ElementConfiguration from "./components/ElementConfiguration";
import ElementPanel from "./components/ElementPanel";
import EventQueuePanel from "./components/EventQueuePanel";
import "./ProjectDetail.scss";

const isObject = (obj: any) => obj === Object(obj);

export default function ProjectDetail({
  onGoToManagerClick,
  activeProjectId,
  onClickPlay,
  projectId,
}: {
  onGoToManagerClick: () => void;
  activeProjectId: string;
  onClickPlay: () => void;
  projectId: string;
}) {
  const { status: projectStatus } = useProject({
    id: projectId,
  });

  const [activeElement, setActiveElement] = useState<
    MapType | Unit | Building | Resource
  >();

  if (projectStatus !== "success") {
    return <></>;
  }

  return (
    <div style={{ minHeight: window.innerHeight }}>
      <ElementPanel
        projectId={projectId}
        activeElement={activeElement}
        setActiveElement={setActiveElement}
        onGoToManagerClick={onGoToManagerClick}
      />
      <ElementConfiguration activeElement={activeElement} />
      <EventQueuePanel />
    </div>
  );
}
